import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { firstValueFrom } from 'rxjs';
import { Tax } from '../_types/tax';
import { TaxesService } from '../_services/taxes.service';

@Component({
    selector: 'app-taxes-detail',
    templateUrl: './taxes-detail.component.html',
    styleUrls: ['./taxes-detail.component.scss'],
    standalone: false
})
export class TaxesDetailComponent {
  public taxFormGroup!: RxFormGroup;

  public tax: Tax = new Tax();

  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private taxesService: TaxesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService
  ) {

    this.taxFormGroup = this.formBuilder.formGroup<Tax>(this.tax) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalles de impuesto");
    this.topbarService.addBreadcrumb("Impuestos", "/taxes");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadTax(id);
    }

    this.allowWrite = true;//this.loginService.hasPermission("VEHICLES_TYPES_WRITE");
    this.allowDelete = true;//this.loginService.hasPermission("VEHICLES_TYPES_DELETE");


  }

  async loadTax(id: string) {
    this.tax = await firstValueFrom(this.taxesService.get(id));
    this.taxFormGroup.patchValue(this.tax);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.taxFormGroup);
    if (valid) {
      this.tax = Object.assign(this.tax, this.taxFormGroup.value);
      let tax = await firstValueFrom(this.taxesService.save(this.tax));
      this.messageService.add({ closable: true, severity: 'success', summary: "Tipo de impuesto guardado correctamente." });
      this.router.navigate(['taxes']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el tipo de impuesto "+this.tax.name+"?",
      header: "Eliminar tipo de impuesto",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.taxesService.delete(this.tax.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Tipo de impuesto eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['taxes']);
  }

}
